import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Role } from '../role';
import { UsersService } from '../users.service';
import { NotificationService } from 'app/_services/notification.service';

@Component({
    templateUrl: 'add-user-dialog.component.html',
    styleUrls: ['add-user-dialog.component.scss']
})
export class AddUserDialogComponent implements OnInit {

    userForm: FormGroup;
    roles: Role[] = [];
    loading = false;

    constructor(
        private formBuilder: FormBuilder,
        private dialogRef: MatDialogRef<AddUserDialogComponent>,
        private usersService: UsersService,
        public notificationService: NotificationService,
    ) {}

    ngOnInit() {
        this.userForm = this.formBuilder.group({
            firstname: ['', [Validators.required]],
            middlename: ['', [Validators.required]],
            lastname: ['', [Validators.required]],
            email: ['', [Validators.required]],
            phone: ['', [Validators.required, Validators.pattern("^((\\+91-?))?[0-9]{9}$")]],
            role: ['', [Validators.required]]
        });

        this.fetchRoles();
    }

    fetchRoles() {
        this.usersService.getRoles().subscribe(
            (response: any) => {
                this.roles = response.data; // Extract roles from 'data'
                if (this.roles.length > 0) {
                    this.userForm.patchValue({ role: this.roles[0] });
                }
            },
            error => {
                console.error('Failed to fetch roles:', error);
                this.notificationService.openSnackBar('Failed to load roles', 'Close', 'error-snackbar', 5000);
            }
        );
    }


    onCloseDialog() {
        this.dialogRef.close();
    }

    onSubmit(value) {
        value.role = value.role.id;

        console.log("User value ", value);
        console.log("Generated Password ", this.generatePassword(4));
        this.loading = true;

        this.usersService.addUser(value).subscribe(
            data => {
                this.loading = false;
                this.notificationService.openSnackBar(data.message, 'Close', 'success-snackbar', 10000);
                this.dialogRef.close();
            },
            error => {
                this.loading = false;
                console.error(error);
                this.notificationService.openSnackBar(error.message, 'Close', 'error-snackbar', 10000);
            }
        );
    }

    generatePassword(passwordLength) {
        const numberChars = "0123456789";
        const upperChars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
        const lowerChars = "abcdefghijklmnopqrstuvwxyz";
        const allChars = numberChars + upperChars + lowerChars;
        const randPasswordArray = Array(passwordLength).fill(allChars);
        randPasswordArray[0] = numberChars;
        randPasswordArray[1] = upperChars;
        randPasswordArray[2] = lowerChars;

        return this.shuffleArray(
            randPasswordArray.map(x => x[Math.floor(Math.random() * x.length)])
        ).join('');
    }

    shuffleArray(array) {
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        return array;
    }
}
